import GetSiHaDocumentationByShareIdRequestModelBase from '../_generated/modelBases/get-si-ha-documentation-by-share-id-request-model-base';

export default class GetSiHaDocumentationByShareIdRequestModel extends GetSiHaDocumentationByShareIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
